module.exports = __webpack_public_path__ + "img/icon.08b40ca2.png";